<template>
  <SkeletonTableLoader :items-length="paymentApplications.length">
    <v-container>
      <v-row justify="end" align-content="end" class="pa-2">
        <v-spacer />
        <v-btn
          rounded
          dense
          small
          color="primary"
          @click="$emit('application-modal')"
          :disabled="!canUserEdit"
        >
          <v-icon> mdi-plus </v-icon>
          {{ $t('payment.application.add')}}
        </v-btn>
      </v-row>
      <PaymentsApplicationsTable
        v-model="paymentApplications"
        :payment-milestones="paymentMilestones"
        @applications-update="$emit('applications-update', $route.params.contractId)"
        @edit-payment="item => $emit('application-modal', item)"
        @update-payment="createOrUpdatePaymentApplication"
        @delete-payment="handleDeletePaymentApplication"
        :chosen-currency="contract.chosenCurrency"
        :currencies="contract.currencies"
        :contract="contract"
      />
    </v-container>
  </SkeletonTableLoader>
</template>

<script>
import {
  addPaymentApplication,
  updatePaymentApplication,
  deletePaymentApplication
} from '@/services'
import { mapState } from 'vuex'

export default {
  name: 'PaymentsApplications',
  props: {
    contract: {
      type: Object,
      default: function () {
        return {}
      }
    },
    paymentApplications: {
      type: Array,
      default: function () {
        return []
      }
    },
    paymentMilestones: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    ...mapState({
      canUserEdit: state => state.userPermissionsToContract.canUserEdit
    })
  },
  data () {
    return {}
  },
  methods: {
    async createOrUpdatePaymentApplication (data) {
      data.id
        ? await updatePaymentApplication(data)
        : await addPaymentApplication(this.$route.params.contractId, data)
      this.$emit('applications-update', this.$route.params.contractId)
      this.$emit('milestones-update', this.$route.params.contractId)
    },
    async handleDeletePaymentApplication (data) {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        scope: {
          message: this.$t('common.deleteConfirm', { name: data.name })
        },
        handlers: {
          yes: async () => {
            await deletePaymentApplication(data)
            this.$emit('applications-update', this.$route.params.contractId)
          }
        }
      })
    }
  }
}
</script>
